import React from "react";
import Profile from "../components/profile/Profile"; // putanja ako je u `components/profile`

const ProfilePage = () => {
  return <Profile />;
};

export default ProfilePage;
